import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/logo.png"
                alt="Blazerex Logo"
                className="h-8 w-auto"
              />
              <span className="h2 text-xl" style={{ color: '#76B900' }}>
                Blazerex
              </span>
            </div>
            <p className="body-text text-gray-400">
              AI-powered FinTech intelligence platform for earnings analysis and market insights.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="sub-header text-lg mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/companies"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  Companies
                </Link>
              </li>
              <li>
                <Link
                  to="/earnings-calls"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  Earnings Calls
                </Link>
              </li>
              <li>
                <Link
                  to="/filings"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  Financial Reports
                </Link>
              </li>
              <li>
                <Link
                  to="/rankings"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  Rankings
                </Link>
              </li>
              <li>
                <Link
                  to="/news"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  News
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="sub-header text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="sub-header text-lg mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/terms"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="body-text text-gray-400 hover:text-blazerex-green transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="body-text text-gray-400">
            © {new Date().getFullYear()} Blazerex. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};


